// extracted by mini-css-extract-plugin
module.exports = {"FooterLogoMenu":"FooterLogoMenu_FooterLogoMenu__1aq1A","Copyright":"FooterLogoMenu_Copyright__1AGZa"};